import React, {
  useEffect,
  useMemo,
} from 'react'
import './index.css'
import MainHeader from '../../components/MainHeader'
import ReportBody from '../../components/ReportsBody'
import ReportFrame from '../../components/ReportsFrame'

const Reports = ({ setReports, reports }) => {
  useEffect(() => {
    setReports()
  }, [])

  const reportsArray = useMemo(() => Object.values(reports))
  const [ jobReports, dealerReports, userReports, genericReports ] = reportsArray

  return (
    <div>
      <MainHeader title="Reports" />
      <div className='reports__line'/>
      <ReportBody title='Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.' />
      <div className='frames'>
          {genericReports && genericReports.filter(report=> (report.paramType === 'no_parameter' || report.paramType === 'time_range')).map((elem, index) =>
            <div>
              <h2 className='frame__title'>{elem.reportName}</h2>
            <ReportFrame description={elem.description} key={index} page="generic" reportName={elem.reportName} paramType={elem.paramType}/>
            </div>
            )}
      </div>
    </div>
  )
}

export default Reports
